
import React, { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Grid,
  LinearProgress,
  IconButton,
  Card,
  CardMedia,
  CardActions,
  CardContent,
  Paper,
} from '@mui/material';
import { Delete, CloudUpload, Done } from '@mui/icons-material';
import AuthContext, { AuthProvider } from '../context/AuthContext'

const UploadScoutingMedia = () => {
  const { report_id } = useParams();
  let { user } = useContext(AuthContext)
  const [files, setFiles] = useState([]); // store File objects
  const [uploadProgress, setUploadProgress] = useState({}); // file.name => progress %


  const handleSubmit = () =>{sessionStorage.removeItem('userPhone'); alert('Successfully submitted', window.location='/select-scouting-report-type')}
  // When user selects files
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    // Add selected files immediately to the UI
    setFiles((prev) => [...prev, ...selectedFiles]);

    // Start upload for each new file
    selectedFiles.forEach(uploadFile);
  };

  // Upload a single file with progress tracking
  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('volunteer_id', user?.username || '');
    // formData.append('innovator_phone', (sessionStorage.getItem('userPhone')) || '');

    const xhr = new XMLHttpRequest();


    // const api_link = `http://localhost:8000/upload-scouting-media/${report_id}`
    const api_link = `https://api.mba-gris.stgafrica.org/upload-scouting-media/${report_id}`
    xhr.open('POST', api_link); // adjust URL as needed

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setUploadProgress((prev) => ({ ...prev, [file.name]: percent }));
      }
    });

    xhr.onload = () => {
      if (xhr.status === 201) {
        setUploadProgress((prev) => ({ ...prev, [file.name]: 100 }));
      } else {
        console.error('Upload failed:', xhr.responseText);
        setUploadProgress((prev) => ({ ...prev, [file.name]: -1 })); // error state
      }
    };

    xhr.onerror = () => {
      console.error('Upload error for:', file.name);
      setUploadProgress((prev) => ({ ...prev, [file.name]: -1 })); // error state
    };

    xhr.send(formData);
  };

  // Remove file from UI and progress state
  const handleRemove = (index) => {
    const filename = files[index].name;
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setUploadProgress((prev) => {
      const copy = { ...prev };
      delete copy[filename];
      return copy;
    });
  };

  return (
    <Box sx={{ p: { xs: 2, md: 5 }, bgcolor: '#f9f9f9', minHeight: '100vh' }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, maxWidth: 1000, mx: 'auto', borderRadius: 4 }}>
        <Typography variant="h4" gutterBottom textAlign="center">
          Upload Media
        </Typography>
        <Typography variant="body1" textAlign="center" mb={3} color="text.secondary">
          Upload multiple images or videos. Files upload immediately after selection.
        </Typography>

        <Box textAlign="center" mb={4}>
          <Button
            variant="contained"
            component="label"
            startIcon={<CloudUpload />}
            sx={{ px: 4, py: 1.5, fontWeight: 'bold', fontSize: '1rem' }}
          >
            Add Files
            <input hidden multiple type="file" accept="image/*,video/*" onChange={handleFileChange} />
          </Button>
        </Box>

        <Grid container spacing={3}>
          {files.map((file, index) => {
            const isVideo = file.type.startsWith('video');
            const previewUrl = URL.createObjectURL(file);
            const progress = uploadProgress[file.name];

            return (
              <Grid item xs={12} sm={6} md={4} key={file.name + index}>
                <Card sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 3 }}>
                  {isVideo ? (
                    <CardMedia
                      component="video"
                      src={previewUrl}
                      controls
                      sx={{ height: 200, bgcolor: '#000' }}
                    />
                  ) : (
                    <CardMedia
                      component="img"
                      src={previewUrl}
                      alt={file.name}
                      sx={{ height: 200, objectFit: 'cover' }}
                    />
                  )}

                  <CardContent sx={{ py: 1, px: 2 }}>
                    <Typography variant="body2" noWrap color="text.secondary" title={file.name}>
                      {file.name}
                    </Typography>
                  </CardContent>

                  <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                    <IconButton onClick={() => handleRemove(index)} color="error" size="small">
                      <Delete />
                    </IconButton>
                  </CardActions>

                  {/* Show progress bar during upload or error */}
                  {progress != null && progress >= 0 && progress < 100 && (
                    <LinearProgress
                      variant="determinate"
                      value={progress}
                      sx={{ height: 6 }}
                    />
                  )}

                  {/* Show green full progress bar at 100% */}
                  {progress === 100 && (
                    <LinearProgress
                      variant="determinate"
                      value={100}
                      sx={{
                        height: 6,
                        bgcolor: '#e0e0e0',
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: 'green',
                        },
                      }}
                    />
                  )}

                  {/* Show error state */}
                  {progress === -1 && (
                    <Box
                      sx={{
                        height: 6,
                        bgcolor: 'red',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        px: 1,
                      }}
                    >
                      Upload failed
                    </Box>
                  )}
                </Card>
              </Grid>
            );
          })}
        </Grid>

        {files.length === 0 ? (
  <Typography mt={5} textAlign="center" color="text.secondary">
    No media selected yet.
  </Typography>
) : (
  <Box textAlign="center" m={4}>
    <Button
      variant="contained"
      startIcon={<Done />}
      sx={{ px: 4, py: 1.5, backgroundColor:'green', width:'70%', fontWeight: 'bold', fontSize: '1rem' }}
      onClick={handleSubmit} // add your submit handler here
    >
      Submit
    </Button>
  </Box>
)}

      </Paper>
    </Box>
  );
};

export default UploadScoutingMedia;
